// extracted by mini-css-extract-plugin
export var techtime = "techtime-module--techtime--wPb7s";
export var title = "techtime-module--title--tXz1r";